module.exports = __webpack_public_path__ + "static/media/w3.b02f5ccc.png";